const SubscriptionServiceBanner = () => {
  return null;
};

export default SubscriptionServiceBanner;
